export default "__VITE_ASSET__BkrY0$SC__"